import { render, staticRenderFns } from "./DataVisualisation.vue?vue&type=template&id=2cf4f57b&scoped=true&"
import script from "./DataVisualisation.vue?vue&type=script&lang=js&"
export * from "./DataVisualisation.vue?vue&type=script&lang=js&"
import style0 from "./DataVisualisation.vue?vue&type=style&index=0&id=2cf4f57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf4f57b",
  null
  
)

component.options.__file = "DataVisualisation.vue"
export default component.exports